export enum CaptureModes {
    NATIVE = 'native',
    WEB = 'web',
    AUTH_ID_SDK = 'authID',
    LIVENESS_CHECK = 'facetec',
    ACUANT_SDK = 'acuant',
}